import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Detect stored preference or fallback
const urlParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
const urlLang = urlParams ? urlParams.get('userLang') || urlParams.get('lang') : null;
const path = typeof window !== 'undefined' ? window.location.pathname : '';
const stored = typeof window !== 'undefined' ? localStorage.getItem('APP_LANG') : null;
const browser = typeof navigator !== 'undefined' ? (navigator.language || navigator.userLanguage || 'en').slice(0, 2) : 'en';

// English paths force 'en' unless a specific param is present
// Basic Path Detection
const englishPaths = ['/runners', '/help', '/privacy-policy', '/terms-of-service', '/coaches-demo'];
const portuguesePaths = ['/atletas', '/support', '/privacy', '/terms', '/treinadores-demo'];

const isExplicitEnglish = englishPaths.some(p => path === p || path.startsWith(p + '/'));
const isExplicitPortuguese = portuguesePaths.some(p => path === p || path.startsWith(p + '/'));

// Priority: 
// 1. URL Query Param (?userLang=en) - override
// 2. Explicit Path (/runners -> en) - override
// 3. LocalStorage (User preference)
// 4. Browser / Default
let detectedLang = null;

if (urlLang) {
  detectedLang = urlLang.slice(0, 2);
} else if (isExplicitEnglish) {
  detectedLang = 'en';
} else if (isExplicitPortuguese) {
  detectedLang = 'pt';
} else {
  detectedLang = stored || (browser === 'pt' ? 'pt' : 'en');
}

const initialLang = detectedLang;

console.log('[i18n Init] Language Detection:', {
  urlLang,
  path,
  isExplicitEnglish,
  isExplicitPortuguese,
  stored,
  browser,
  initialLang,
  search: window.location.search
});

// Persistencia: se veio da URL, salva para as próximas navegações
if (urlLang && typeof window !== 'undefined') {
  try {
    localStorage.setItem('APP_LANG', initialLang);
  } catch (e) {
    console.warn('Failed to save language to localStorage:', e);
  }
}

import commonEn from './resources/en/common.json';
import commonPt from './resources/pt/common.json';

// Basic resources namespace (expand later)
const resources = {
  en: { common: commonEn },
  pt: { common: commonPt }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLang,
    fallbackLng: 'pt',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    returnEmptyString: false,
    detection: { order: ['localStorage', 'navigator'] }
  });

export function setLanguage(lang) {
  console.log('Changing language to:', lang);
  i18n.changeLanguage(lang);
  try {
    localStorage.setItem('APP_LANG', lang);
    console.log('Language saved to localStorage:', lang);
  } catch (e) {
    console.error('Failed to save language:', e);
  }
}

export default i18n;
